'use strict';

bbw.directive.bbwPage = ['bbw.LocationSvc', function(locationSvc) {
    return {
        priority: 0,
        restrict: 'EA',
        scope: true,
        compile: function(element) {
            locationSvc.setContainerElement(element);
            return angular.noop;
        }
    };
}];
